const $ = require('jquery');

window.$ = window.jQuery = $;

require('popper.js/dist/umd/popper.min');
window.bootstrap = require('bootstrap/dist/js/bootstrap.min');
require('jquery-validation/dist/jquery.validate.min');
require('datatables/media/js/jquery.dataTables.min');
require('datatables.net-bs4/js/dataTables.bootstrap4.min');
require('datatables.net-colreorder-bs/js/colReorder.bootstrap.min');
require('datatables.net-select/js/dataTables.select.min');
require('datatables.net-buttons/js/dataTables.buttons.min');
require('datatables.net-buttons-bs4/js/buttons.bootstrap4.min');
require('datatables.net-buttons/js/buttons.html5.min');
require('datatables.net-buttons/js/buttons.print.min');
require('datatables.net-responsive/js/dataTables.responsive.min');
require('bootstrap-duallistbox/dist/jquery.bootstrap-duallistbox.min');
require('chosen-js/chosen.jquery.min');
window.TinyDatePicker = require('tiny-date-picker/dist/tiny-date-picker.min');
require('lightbox2/dist/js/lightbox.min');
const Sortable = require('sortablejs/Sortable.min');
require('x-editable-4-bs4/dist/bootstrap4-editable/js/bootstrap-editable.min');
const moment = require('moment/dist/moment');
require('moment/dist/locale/es');
const bootbox = require('bootbox/dist/bootbox.all.min');
const {each} = require("lodash");

/**
 * This plug-in for DataTables represents the ultimate option in extensibility
 * for sorting date / time strings correctly. It uses
 * [Moment.js](http://momentjs.com) to create automatic type detection and
 * sorting plug-ins for DataTables based on a given format. This way, DataTables
 * will automatically detect your temporal information and sort it correctly.
 *
 * For usage instructions, please see the DataTables blog
 * post that [introduces it](//datatables.net/blog/2014-12-18).
 *
 * @name Ultimate Date / Time sorting
 * @summary Sort date and time in any format using Moment.js
 * @author [Allan Jardine](//datatables.net)
 * @depends DataTables 1.10+, Moment.js 1.7+
 *
 * @example
 *    $.fn.dataTable.moment( 'HH:mm MMM D, YY' );
 *    $.fn.dataTable.moment( 'dddd, MMMM Do, YYYY' );
 *
 *    $('#example').DataTable();
 */

(function (factory) {
    if (typeof define === "function" && define.amd) {
        define(["jquery", "moment", "datatables.net"], factory);
    } else {
        factory(jQuery, moment);
    }
}(function ($, moment) {

    function strip(d) {
        if (typeof d === 'string') {
            // Strip HTML tags and newline characters if possible
            d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');

            // Strip out surrounding white space
            d = d.trim();
        }

        return d;
    }

    $.fn.dataTable.moment = function (format, locale, reverseEmpties) {
        let types = $.fn.dataTable.ext.type;

        // Add type detection
        types.detect.unshift(function (d) {
            d = strip(d);

            // Null and empty values are acceptable
            if (d === '' || d === null) {
                return 'moment-' + format;
            }

            return moment(d, format, locale, true).isValid() ?
                'moment-' + format :
                null;
        });

        // Add sorting method - use an integer for the sorting
        types.order['moment-' + format + '-pre'] = function (d) {
            d = strip(d);

            return !moment(d, format, locale, true).isValid() ?
                (reverseEmpties ? -Infinity : Infinity) :
                parseInt(moment(d, format, locale, true).format('x'), 10);
        };
    };

}));

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: ES (Spanish; Español)
 */
$.extend($.validator.messages, {
    required: "Este campo es obligatorio.",
    remote: "Por favor, rellena este campo.",
    email: "Por favor, escribe una dirección de correo válida.",
    url: "Por favor, escribe una URL válida.",
    date: "Por favor, escribe una fecha válida.",
    dateISO: "Por favor, escribe una fecha (ISO) válida.",
    number: "Por favor, escribe un número válido.",
    digits: "Por favor, escribe sólo dígitos.",
    creditcard: "Por favor, escribe un número de tarjeta válido.",
    equalTo: "Por favor, escribe el mismo valor de nuevo.",
    extension: "Por favor, escribe un valor con una extensión aceptada.",
    maxlength: $.validator.format("Por favor, no escribas más de {0} caracteres."),
    minlength: $.validator.format("Por favor, no escribas menos de {0} caracteres."),
    rangelength: $.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
    range: $.validator.format("Por favor, escribe un valor entre {0} y {1}."),
    max: $.validator.format("Por favor, escribe un valor menor o igual a {0}."),
    min: $.validator.format("Por favor, escribe un valor mayor o igual a {0}."),
    nifES: "Por favor, escribe un NIF válido.",
    nieES: "Por favor, escribe un NIE válido.",
    cifES: "Por favor, escribe un CIF válido."
});

const $invalidClass = 'brc-danger-tp2';
const $validClass = 'brc-info-tp2';
jQuery.validator.setDefaults({
    errorElement: 'span',
    errorClass: 'form-text form-error text-danger-m2 w-100',
    focusInvalid: false,
    ignore: "",
    highlight: function (element) {
        let $element = $(element);

        //remove error messages to be inserted again, so that the `.fa-exclamation-circle` is inserted in `errorPlacement` function
        $element.closest('.form-group').find('.form-text').remove()

        if ($element.is('input[type=checkbox]') || $element.is('input[type=radio]')) return

        else if ($element.is('.select2')) {
            let container = $element.siblings('[class*="select2-container"]')
            container.find('.select2-selection').addClass($invalidClass)
        } else if ($element.is('.chosen')) {
            let container = $element.siblings('[class*="chosen-container"]');
            container.find('.chosen-choices, .chosen-single').addClass($invalidClass)
        } else {
            $element.addClass($invalidClass + ' d-inline-block').removeClass($validClass)
        }
    },

    errorPlacement: function (error, element) {
        // prepend 'fa-exclamation-circle' icon
        error.prepend('<i class="fa fa-exclamation-circle text-danger-m1 text-100 mr-2"></i>')

        if (element.is('input[type=checkbox]') || element.is('input[type=radio]')) {
            element.closest('div[class*="col-"]').append(error)
        } else if (element.is('.select2')) {
            let container = element.siblings('[class*="select2-container"]')
            error.insertAfter(container)
            container.find('.select2-selection').addClass($invalidClass)
        } else if (element.is('.chosen')) {
            let container = element.siblings('[class*="chosen-container"]')
            error.insertAfter(container)
            container.find('.chosen-choices, .chosen-single').addClass($invalidClass)
        } else {
            error.addClass('d-inline-block').insertAfter(element)
        }
    }
});

jQuery(function ($) {
    const iconLoading = '<i class="fas fa-cog fa-spin text-blue mr-1"></i>';
    const textLoading = 'Cargando...';
    const templateTooltip = '<div class="tooltip" role="tooltip"><div class="brc-dark-d1 arrow"></div><div class="bgc-dark-d1 tooltip-inner text-105 text-400"></div></div>';

    $.fn.dataTable.moment('dd/MM/YYYY HH:mm:ss');
    $.extend(true, $.fn.dataTable.defaults, {
        stateSave: true,
        renderer: 'bootstrap',
        language: {
            "processing": "Procesando...",
            "lengthMenu": "Mostrar _MENU_ registros",
            "zeroRecords": "No se encontraron resultados",
            "emptyTable": "Ningún dato disponible en esta tabla",
            "info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
            "search": "Buscar:",
            "infoThousands": ",",
            "loadingRecords": "Cargando...",
            "paginate": {
                "first": "Primero",
                "last": "Último",
                "next": "Siguiente",
                "previous": "Anterior"
            },
            "aria": {
                "sortAscending": ": Activar para ordenar la columna de manera ascendente",
                "sortDescending": ": Activar para ordenar la columna de manera descendente"
            },
            "buttons": {
                "copy": "Copiar",
                "colvis": "Visibilidad",
                "collection": "Colección",
                "colvisRestore": "Restaurar visibilidad",
                "copyKeys": "Presione ctrl o u2318 + C para copiar los datos de la tabla al portapapeles del sistema. <br \/> <br \/> Para cancelar, haga clic en este mensaje o presione escape.",
                "copySuccess": {
                    "1": "Copiada 1 fila al portapapeles",
                    "_": "Copiadas %d fila al portapapeles"
                },
                "copyTitle": "Copiar al portapapeles",
                "csv": "CSV",
                "excel": "Excel",
                "pageLength": {
                    "-1": "Mostrar todas las filas",
                    "1": "Mostrar 1 fila",
                    "_": "Mostrar %d filas"
                },
                "pdf": "PDF",
                "print": "Imprimir"
            },
            "autoFill": {
                "cancel": "Cancelar",
                "fill": "Rellene todas las celdas con <i>%d<\/i>",
                "fillHorizontal": "Rellenar celdas horizontalmente",
                "fillVertical": "Rellenar celdas verticalmente"
            },
            "decimal": ",",
            "searchBuilder": {
                "add": "Añadir condición",
                "button": {
                    "0": "Constructor de búsqueda",
                    "_": "Constructor de búsqueda (%d)"
                },
                "clearAll": "Borrar todo",
                "condition": "Condición",
                "conditions": {
                    "date": {
                        "after": "Después",
                        "before": "Antes",
                        "between": "Entre",
                        "empty": "Vacío",
                        "equals": "Igual a",
                        "notBetween": "No entre",
                        "notEmpty": "No Vacío",
                        "not": "Diferente de"
                    },
                    "number": {
                        "between": "Entre",
                        "empty": "Vacío",
                        "equals": "Igual a",
                        "gt": "Mayor a",
                        "gte": "Mayor o igual a",
                        "lt": "Menor que",
                        "lte": "Menor o igual que",
                        "notBetween": "No entre",
                        "notEmpty": "No vacío",
                        "not": "Diferente de"
                    },
                    "string": {
                        "contains": "Contiene",
                        "empty": "Vacío",
                        "endsWith": "Termina en",
                        "equals": "Igual a",
                        "notEmpty": "No Vacío",
                        "startsWith": "Empieza con",
                        "not": "Diferente de"
                    },
                    "array": {
                        "not": "Diferente de",
                        "equals": "Igual",
                        "empty": "Vacío",
                        "contains": "Contiene",
                        "notEmpty": "No Vacío",
                        "without": "Sin"
                    }
                },
                "data": "Data",
                "deleteTitle": "Eliminar regla de filtrado",
                "leftTitle": "Criterios anulados",
                "logicAnd": "Y",
                "logicOr": "O",
                "rightTitle": "Criterios de sangría",
                "title": {
                    "0": "Constructor de búsqueda",
                    "_": "Constructor de búsqueda (%d)"
                },
                "value": "Valor"
            },
            "searchPanes": {
                "clearMessage": "Borrar todo",
                "collapse": {
                    "0": "Paneles de búsqueda",
                    "_": "Paneles de búsqueda (%d)"
                },
                "count": "{total}",
                "countFiltered": "{shown} ({total})",
                "emptyPanes": "Sin paneles de búsqueda",
                "loadMessage": "Cargando paneles de búsqueda",
                "title": "Filtros Activos - %d"
            },
            "select": {
                "1": "%d fila seleccionada",
                "_": "%d filas seleccionadas",
                "cells": {
                    "1": "1 celda seleccionada",
                    "_": "$d celdas seleccionadas"
                },
                "columns": {
                    "1": "1 columna seleccionada",
                    "_": "%d columnas seleccionadas"
                }
            },
            "thousands": ".",
            "datetime": {
                "previous": "Anterior",
                "next": "Próximo",
                "hours": "Horas",
                "minutes": "Minutos",
                "seconds": "Segundos",
                "unknown": "-",
                "amPm": [
                    "am",
                    "pm"
                ]
            },
            "editor": {
                "close": "Cerrar",
                "create": {
                    "button": "Nuevo",
                    "title": "Crear Nuevo Registro",
                    "submit": "Crear"
                },
                "edit": {
                    "button": "Editar",
                    "title": "Editar Registro",
                    "submit": "Actualizar"
                },
                "remove": {
                    "button": "Eliminar",
                    "title": "Eliminar Registro",
                    "submit": "Eliminar",
                    "confirm": {
                        "_": "¿Está seguro que desea eliminar %d filas?",
                        "1": "¿Está seguro que desea eliminar 1 fila?"
                    }
                },
                "error": {
                    "system": "Ha ocurrido un error en el sistema (<a target=\"\\\" rel=\"\\ nofollow\" href=\"\\\">Más información&lt;\\\/a&gt;).<\/a>"
                },
                "multi": {
                    "title": "Múltiples Valores",
                    "info": "Los elementos seleccionados contienen diferentes valores para este registro. Para editar y establecer todos los elementos de este registro con el mismo valor, hacer click o tap aquí, de lo contrario conservarán sus valores individuales.",
                    "restore": "Deshacer Cambios",
                    "noMulti": "Este registro puede ser editado individualmente, pero no como parte de un grupo."
                }
            }
        },
        drawCallback: function () {
            $("[data-toggle='tooltip']").tooltip({
                container: 'body',
                template: templateTooltip
            });
        }
    });

    setTimeout(function () {
        //enable tooltips
        $('.dt-buttons button')
            .each(function () {
                let div = $(this).find('span').first()
                if (div.length == 1) {
                    $(this).tooltip({
                        container: 'body',
                        title: div.parent().text(),
                        template: templateTooltip
                    })
                } else {
                    $(this).tooltip({
                        container: 'body',
                        title: $(this).text(),
                        template: templateTooltip
                    });
                }
            });
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body',
            template: templateTooltip
        });
        //add class thead
        $('.dataTables_wrapper').find('thead').addClass('sticky-nav text-secondary-d1 text-uppercase text-95');
        // add a dark border
        $('.dataTables_wrapper')
            .addClass('border-b-1 border-x-1 brc-default-l2 border-t-3 w-100')
            // highlight DataTable header
            // also already done in CSS, but you can use custom colors here
            .find('.row:first-of-type')
            .addClass('border-b-1 brc-default-l3 bgc-blue-l4')
            .next().addClass('mt-n1px'); // move the next `.row` up by 1px to go below header's border
        // if the table has scrollbars, add ace styling to it
        $('.dataTables_scrollBody').aceScroll({color: "grey"});
    }, 0);

    // duallist box
    let duallist = $('.duallist').bootstrapDualListbox({
        infoTextFiltered: '<span class="badge badge-purple badge-lg">Filtrar</span>',
        filterTextClear: 'Mostrar todo',
        filterPlaceHolder: 'Filtrar',
        moveSelectedLabel: 'Mover seleccionado',
        moveAllLabel: 'Mover todo',
        removeSelectedLabel: 'Quitar seleccionado',
        removeAllLabel: 'Quitar todo',
        infoText: 'Mostrando todo {0}',
        infoTextEmpty: 'Lista vacía'
    });
    let container1 = duallist.bootstrapDualListbox('getContainer');
    container1.find('.btn').removeClass('btn-default').addClass('btn-xs btn-outline-info btn-h-outline-info btn-bold m-0')
        .find('.glyphicon-arrow-right').attr('class', 'fa fa-arrow-right').end()
        .find('.glyphicon-arrow-left').attr('class', 'fa fa-arrow-left');

    // chosen
    $(".chosen-select").chosen({allow_single_deselect: true});

    //form validate
    $('.form-validate').validate();

    // datepicker
    if ($('.datepicker').length) {
        const inputs = Array.prototype.slice.call(document.querySelectorAll('.datepicker'));
        let lengthInputs = inputs.length;
        for (let i = 0; i < lengthInputs; i++) {
            TinyDatePicker(inputs[i], {
                mode: 'dp-below',
                // Lang can be used to customize the text that is displayed
                // in the calendar. You can use this to display a different language.
                lang: {
                    days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    today: 'Hoy',
                    clear: 'Limpiar',
                    close: 'Cerrar',
                },
                // format {Date} -> string is a function which takes a date and returns a string. It can be used to customize
                // the way a date will look in the input after the user has selected it, and is particularly
                // useful if you're targeting a non-US customer.
                format(date) {
                    return date.toLocaleDateString('es-ES', {year: 'numeric', month: '2-digit', day: '2-digit'});
                },
                // parse {string|Date} -> Date is the inverse of format. If you specify one, you probably should specify the other
                // the default parse function handles whatever the new Date constructor handles. Note that
                // parse may be passed either a string or a date.
                parse(str) {
                    let date = new Date(str);
                    return isNaN(date) ? new Date() : date.toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    });
                },
                // dayOffset {number} specifies which day of the week is considered the first. By default,
                // this is 0 (Sunday). Set it to 1 for Monday, 2 for Tuesday, etc.
                dayOffset: 1
            });
        }
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    //Active/deactivate posts
    $(document.body).on('click', '[data-active]', function (e) {
        e.preventDefault();
        let $route = $(this).data('route');
        let $parent = $(this).parent('.wrap-active');
        $parent.html(iconLoading);
        $.ajax({
            url: $route,
            method: 'POST'
        }).done(function (response) {
            $parent.html(response);
        });
    });

    // file input in edit profile
    $('#avatar').aceFileInput({
        style: 'drop',
        droppable: false,
        container: 'border-1 border-dashed brc-grey-m4 brc-h-warning-m1',
        placeholderClass: 'text-125 text-600 text-grey-l1 my-2',
        placeholderText: 'Haga clic aquí para elegir la imagen de perfil',
        placeholderIcon: '<i class="fa fa-user fa-3x text-green-m3 my-2"></i>',
        thumbnail: 'large',
        allowMime: 'image/*'
    });

    $('.ace-file-single').aceFileInput({
        btnChooseClass: 'bgc-grey-l2 pt-15 px-2 my-1px mr-1px',
        btnChooseText: 'Seleccione fichero',
        btnChangeText: 'Cambiar',
        placeholderText: 'No se ha seleccionado ningún fichero',
        placeholderIcon: '<i class="fa fa-file bgc-warning-m1 text-white w-4 py-2 text-center"></i>',
        denyMime: 'image/*'
    });

    $('.ace-image-single').aceFileInput({
        style: 'drop',
        droppable: false,
        container: 'border-1 border-dashed brc-grey-l1 brc-h-info-m2 shadow-sm',
        placeholderClass: 'text-125 text-600 text-grey-l1 my-2',
        placeholderText: 'Haga clic aquí para elegir la imagen',
        placeholderIcon: '<i class="fa fa-cloud-upload-alt fa-3x text-info-m2 my-2"></i>',
        thumbnail: 'small',
        allowMime: 'image/*'
    });

    // multiple with image preview
    $('.ace-image-multiple').aceFileInput({
        style: 'drop',
        droppable: false,
        container: 'border-1 border-dashed brc-grey-l1 brc-h-info-m2 shadow-sm',
        placeholderClass: 'text-125 text-600 text-grey-l1 my-2',
        placeholderText: 'Haz clic aquí para elegir las imágenes',
        placeholderIcon: '<i class="fa fa-cloud-upload-alt fa-3x text-info-m2 my-2"></i>',
        thumbnail: 'large',
        allowMime: 'image/*'
    });

    $('.ace-file-multiple').aceFileInput({
        style: 'drop',
        droppable: false,
        container: 'border-1 border-dashed brc-grey-l1 brc-h-info-m2 shadow-sm',
        placeholderClass: 'text-125 text-600 text-grey-l1 my-2',
        placeholderText: 'Haz clic aquí para elegir los ficheros',
        placeholderIcon: '<i class="fa fa-cloud-upload-alt fa-3x text-info-m2 my-2"></i>',
        thumbnail: 'small',
        denyMime: 'image/*'
    });

    //list images
    if ($('#imagesAjax').length) {
        imagesAjax();
    }

    function imagesAjax() {
        let $this = $('#imagesAjax');
        let $route = $this.data('route');
        $this.html(iconLoading + textLoading);
        $.ajax({
            url: $route,
            method: 'POST'
        }).done(function (response) {
            $this.html(response);
        });
    }

    //list files
    if ($('#filesAjax').length) {
        filesAjax();
    }

    function filesAjax() {
        let $this = $('#filesAjax');
        let $route = $this.data('route');
        $this.html(iconLoading + textLoading);
        $.ajax({
            url: $route,
            method: 'POST'
        }).done(function (response) {
            $this.html(response);
        });
    }

    $(document).ajaxSuccess(function () {
        // Sortable for elements loaded by ajax
        $(".sortable").each(function () {
            Sortable.create(this, {
                animation: 100,
                handle: ".drag-handle",
                onUpdate: function (evt) {
                    let item = $(evt.item); // the current dragged HTMLElement
                    let order = item.index() + 1;
                    let $route = item.closest('[data-route]').data('route');
                    $.ajax({
                        url: $route,
                        type: 'GET',
                        data: {
                            id: item.data("id"),
                            order: order
                        },
                    }).fail(function () {
                        alert('Error al ordenar');
                    });
                }
            });
        });

        //Edit name image
        $('.edit-image-name').editable({
            mode: 'inline',
            success: function (response, newValue) {
                $.ajax({
                    url: $(this).data('route'),
                    method: 'POST',
                    data: {name: newValue}
                }).fail(function () {
                    alert('Error al renombrar la imagen');
                });
            }
        });

        //Edit name file
        $('.edit-file-name').editable({
            mode: 'inline',
            success: function (response, newValue) {
                $.ajax({
                    url: $(this).data('route'),
                    method: 'POST',
                    data: {name: newValue}
                }).fail(function () {
                    alert('Error al renombrar el fichero');
                });
            }
        });
    });

    //Delete image
    $(document.body).on('click', '[data-delete-image]', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $id = $this.data('id');
        let $route = $this.data('route');
        bootbox.confirm({
            message: '¿Realmente desea eliminar esta imagen?',
            locale: 'es',
            onEscape: true,
            buttons: {
                confirm: {
                    className: 'btn-success'
                },
                cancel: {
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    $('#list-' + $id).remove();
                    $.ajax({
                        url: $route,
                        method: 'POST'
                    }).fail(function () {
                        alert('Error al eliminar la imagen');
                    });
                }
            }
        });
    });

    //Delete file
    $(document.body).on('click', '[data-delete-file]', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $id = $this.data('id');
        let $route = $this.data('route');
        bootbox.confirm({
            message: '¿Realmente desea eliminar este fichero?',
            locale: 'es',
            onEscape: true,
            buttons: {
                confirm: {
                    className: 'btn-success'
                },
                cancel: {
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    $('#list-' + $id).remove();
                    $.ajax({
                        url: $route,
                        method: 'POST'
                    }).fail(function () {
                        alert('Error al eliminar el fichero');
                    });
                }
            }
        });
    });

    //Sortable
    $(".sortable").each(function () {
        Sortable.create(this, {
            animation: 100,
            handle: ".drag-handle",
            onUpdate: function (evt) {
                let item = $(evt.item); // the current dragged HTMLElement
                let order = item.index() + 1;
                let $route = item.closest('[data-route]').data('route');
                $.ajax({
                    url: $route,
                    type: 'POST',
                    data: {
                        id: item.data("id"),
                        order: order,
                        currentOrder: item.data("currentOrder")
                    },
                }).done(function () {
                    location.reload();
                }).fail(function () {
                    alert('Error al ordenar');
                });
            }
        });
    });

    //Sortable multiple
    $(".sortable-multiple").each(function () {
        Sortable.create(this, {
            animation: 100,
            handle: ".drag-handle",
            onUpdate: function (evt) {
                let item = $(evt.item); // the current dragged HTMLElement
                let order = item.index() + 1;
                let $route = item.closest('[data-route]').data('route');
                $.ajax({
                    url: $route,
                    type: 'POST',
                    data: {
                        id: item.data("id"),
                        order: order,
                        current_order: item.data("current-order"),
                        parent: item.data("parent")
                    },
                }).done(function () {
                    location.reload();
                }).fail(function () {
                    alert('Error al ordenar');
                });
            }
        });
    });

    function refreshFiles() {
        if ($('#imagesAjax').length) {
            imagesAjax();
        }
        if ($('#filesAjax').length) {
            filesAjax();
        }
    }

    $(document.body).on('click', '.refreshFiles', function () {
        refreshFiles();
    });

    // BootBox
    $(document.body).on('click', '.bootbox-alert', function (e) {
        e.preventDefault();
        let $msgAlert = $(this).data('msg-alert');
        bootbox.alert({
            message: $msgAlert,
            locale: 'es',
            onEscape: true,
            callback: function () {
            }
        });
    });

    $(document.body).on('click', '.bootbox-confirm', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $msgAlert = $this.data('msg-alert');
        let $href = '';
        if ($this.prop('href')) {
            $href = $this.attr('href');
        }
        bootbox.confirm({
            message: $msgAlert,
            locale: 'es',
            onEscape: true,
            buttons: {
                confirm: {
                    className: 'btn-success'
                },
                cancel: {
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    if ($href !== '') {
                        window.location.href = $href;
                    } else {
                        $this.closest('form').submit();
                    }
                }
            }
        });
    });

    //list images modal
    $(document.body).on('click', '#btnImageManagerModal', function () {
        let $this = $('#imageManagerModal');
        let $modalBody = $this.find('.modal-body');
        let $route = $this.data('route');
        $modalBody.html(iconLoading + textLoading);
        $.ajax({
            url: $route,
            method: 'GET'
        }).done(function (response) {
            $modalBody.html(response);
        });
    });

    $(document.body).on('click', '.attachImageModal', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $route = $this.data('route');
        $this.html(iconLoading);
        $.ajax({
            url: $route,
            method: 'POST',
            dataType: 'json'
        }).done(function (response) {
            $('#image_id').val(response.id);
            $('#imageSelected').removeClass('d-none').find('img').attr('src', response.image);
            $('#imageManagerModal').modal('hide');
        });
    });

    //list files modal
    $(document.body).on('click', '#btnFileManagerModal', function () {
        let $this = $('#fileManagerModal');
        let $modalBody = $this.find('.modal-body');
        let $route = $this.data('route');
        $modalBody.html(iconLoading + textLoading);
        $.ajax({
            url: $route,
            method: 'GET'
        }).done(function (response) {
            $modalBody.html(response);
        });
    });

    $(document.body).on('click', '.attachFileModal', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $route = $this.data('route');
        $this.html(iconLoading);
        $.ajax({
            url: $route,
            method: 'POST',
            dataType: 'json'
        }).done(function (response) {
            $('#file_id').val(response.id);
            $('#fileSelected').removeClass('d-none').find('a').attr('href', response.file).find('span').text(response.name);
            $('#fileManagerModal').modal('hide');
        });
    });

    $(document.body).on('click', '.attachDetach', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $route = $this.find('a').data('route');
        $this.html(iconLoading);
        $.ajax({
            url: $route,
            method: 'GET',
            dataType: 'html'
        }).done(function (response) {
            refreshFiles();
            $this.html(response);
        });
    });

});
